import { create } from 'zustand';

const useAppStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  clientConfig: {
    id: 'default',
    primaryColor: '#cf6428',
    secondaryColor: '#0d3e6b',
    companyName: 'Tecnofibras',
    logo: null,
    customFields: {},
    theme: 'light',
  },

  setUser: (user) => set({ user, isAuthenticated: !!user }),

  setClientConfig: (config) => set((state) => ({
    clientConfig: { ...state.clientConfig, ...config }
  })),

  setCustomFields: (module, fields) => set((state) => ({
    clientConfig: {
      ...state.clientConfig,
      customFields: {
        ...state.clientConfig.customFields,
        [module]: fields,
      },
    },
  })),

  logout: () => set({ user: null, isAuthenticated: false }),
}));

export default useAppStore;